import { DateTime } from 'luxon';
import { Weekday } from '@api/restaurant/weekday';
import { RestaurantItem } from '@api/restaurant/restaurant-item';

export function getCurrentWeekday(): Weekday {
  switch (new Date().getDay()) {
    case 0:
      return 'sun'
    case 1:
      return 'mo'
    case 2:
      return 'tue'
    case 3:
      return 'wed'
    case 4:
      return 'thu'
    case 5:
      return 'fri'
    case 6:
      return 'sat'
  }

  throw new Error('unable to get weekday')
}

export interface AvailableTime {
  text: string; hour: number; minute: number;
  duration: string | null
}

export function getAvailableTimes(restaurant: RestaurantItem): AvailableTime[] {
  const currentWeekday = getCurrentWeekday()
  const now = DateTime.now();
  const holidays = restaurant.holidays
    .map(h => DateTime.fromJSDate(new Date(h)))
    .filter(h => h.hasSame(now, 'day'))

  if (holidays.some(h => h < now)) {
    return []
  }

  const days = restaurant.openingHours
    .filter(oh => oh.weekday === currentWeekday)
    .map(oh => ({
      from: DateTime.fromFormat(oh.from, 'HH:mm'),
      to: DateTime.fromFormat(oh.to, 'HH:mm'),
    }))
    .filter(oh => oh.to > now)

  const dates: DateTime[] = []
  for (const day of days) {
    dates.push(...getRanges(day.from, day.to));
  }

  const soonestDeliveryDate = now.plus({minutes: 30})
  const availableDates = dates.filter(d => d > soonestDeliveryDate)
  return availableDates
    .filter(d => holidays.every(h => d < h))
    .map(date => ({
      text: date.toFormat('HH:mm'),
      hour: date.hour,
      minute: date.minute,
      duration: date.toRelative()
    }))
}

function getRanges(from: DateTime, to: DateTime): DateTime[] {
  const result: DateTime[] = [from]
  let current = from;
  do {
    current = current.plus({minutes: 30})
    if (current < to) {
      result.push(current)
    }
  } while (current < to)
  result.push(to);
  return result
}
